import axios from 'axios';
import { variables } from '../Variables';

export const getEstateJobStatus = async (estateId) => {
    try {
        let url = `${variables.API_URL}LocalEvents/GetEstateJobStatus?estateId=${estateId}`;

        const jsonconfig = {
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        };

        const response = await axios.get(url, jsonconfig);

        if (response.data) {
            //console.log(response.data);
            return response.data;
        }
    } catch (error) {
        console.log("api error", error);
        return "error";
    }
}

export const htmlToPlainText = (html) => {
    if (!html || typeof html !== 'string') return '';

    return html
        // ── 1. Remove <style> and <script> blocks entirely ──
        .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '')
        .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, '')
        .replace(/<head[^>]*>[\s\S]*?<\/head>/gi, '')

        // ── 2. Replace <br> / <br/> / <br /> with newline ──
        .replace(/<br\s*\/?>/gi, '\n')

        // ── 3. Block-level elements → newline ──
        .replace(/<\/?(address|article|aside|blockquote|canvas|dd|dl|dt|fieldset|figcaption|figure|footer|form|h[1-6]|header|hr|li|main|nav|noscript|ol|p|pre|section|summary|table|tfoot|thead|tbody|tr|td|th|ul|video|div)[^>]*>/gi, '\n')

        // ── 4. <hr> → visible separator ──
        .replace(/<hr[^>]*>/gi, '\n─────────────────────\n')

        // ── 5. Handle list items with bullet ──
        .replace(/<li[^>]*>/gi, '\n• ')

        // ── 6. Links → keep text only ──
        .replace(/<a[^>]*href="([^"]*)"[^>]*>([\s\S]*?)<\/a>/gi, '$2')

        // ── 7. Images → alt text if available ──
        .replace(/<img[^>]*alt="([^"]+)"[^>]*>/gi, '[$1]')
        .replace(/<img[^>]*>/gi, '')

        // ── 8. Strip all remaining HTML tags ──
        .replace(/<[^>]+>/g, '')

        // ── 9. Decode HTML entities ──
        .replace(/&nbsp;/g, ' ')
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        .replace(/&#39;/g, "'")
        .replace(/&apos;/g, "'")
        .replace(/&copy;/g, '©')
        .replace(/&reg;/g, '®')
        .replace(/&trade;/g, '™')
        .replace(/&mdash;/g, '—')
        .replace(/&ndash;/g, '–')
        .replace(/&bull;/g, '•')
        .replace(/&hellip;/g, '...')
        .replace(/&euro;/g, '€')
        .replace(/&pound;/g, '£')
        .replace(/&yen;/g, '¥')
        .replace(/&#(\d+);/g, (_, code) => String.fromCharCode(Number(code)))        // decimal
        .replace(/&#x([0-9a-f]+);/gi, (_, hex) => String.fromCharCode(parseInt(hex, 16))) // hex

        // ── 10. Clean up whitespace ──
        .replace(/\t/g, ' ')                     // tabs → space
        .replace(/ {2,}/g, ' ')                  // multiple spaces → single
        .replace(/ +\n/g, '\n')                  // trailing spaces before newline
        .replace(/\n +/g, '\n')                  // leading spaces after newline
        .replace(/\n{3,}/g, '\n\n')             // 3+ newlines → 2
        .trim();
}

// get property status from estate table in local db
export const getEstateStatusFromInDB = async (estateId, clientId) => {
    try {       // replace propertyId => getActiveLatestEstateIdInDB
        let url = `${variables.API_URL}LocalEvents/GetEstateStatus?estateId=${estateId}&clientId=${clientId}`;
        const config = {
            headers: {
                'Content-Type': 'application/json'
            },
        };

        let response = await axios.get(url, config);
        if (response.data) {
            return response.data;
        }
    } catch (error) {
        console.log(error);
    }
}
